<script>
import IndexPage from './_lang/index.vue';
export default IndexPage;
</script>